export const RecurringFrequency = {
    WEEKLY: "WEEKLY",
    MONTHLY: "MONTHLY",
    QUARTERLY: "QUARTERLY",
    YEARLY: "YEARLY",
};
//# sourceMappingURL=recurring-frequency.enum.js.map